import { Action } from '@ngrx/store'
import * as StaticContentTemplatesTypes from './static-content-templates.types'
import { StaticContentTemplate } from './static-content-templates.interface'

// Fetch Static Content Templates Types
export class FetchStaticContentTemplatesRequest implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchStaticContentTemplatesSuccess implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_SUCCESS
  constructor(public payload: StaticContentTemplate[]) {}
}

export class FetchStaticContentTemplatesFailure implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_FAILURE
  constructor(public payload: any) {}
}

// Fetch Static Content Template Type
export class FetchStaticContentTemplateRequest implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_REQUEST
  constructor(public id: string, public lang: string) {}
}

export class FetchStaticContentTemplateSuccess implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_SUCCESS
  constructor(public payload: StaticContentTemplate) {}
}

export class FetchStaticContentTemplateFailure implements Action {
  readonly type =
    StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

// Delete Static Content Template Type
export class DeleteStaticContentTemplateRequest implements Action {
  readonly type =
    StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_REQUEST
  constructor(public id: string) {}
}

export class DeleteStaticContentTemplateSuccess implements Action {
  readonly type =
    StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_SUCCESS
  constructor() {}
}

export class DeleteStaticContentTemplateFailure implements Action {
  readonly type =
    StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

// Update Static Content Template Type
export class UpdateStaticContentTemplateRequest implements Action {
  readonly type =
    StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_REQUEST
  constructor(public id: string, public payload) {}
}

export class UpdateStaticContentTemplateSuccess implements Action {
  readonly type =
    StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_SUCCESS
  constructor() {}
}

export class UpdateStaticContentTemplateFailure implements Action {
  readonly type =
    StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = StaticContentTemplatesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = StaticContentTemplatesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateStaticContentTemplateRequest
  | UpdateStaticContentTemplateSuccess
  | UpdateStaticContentTemplateFailure
  | FetchStaticContentTemplatesSuccess
  | FetchStaticContentTemplatesFailure
  | FetchStaticContentTemplatesRequest
  | DeleteStaticContentTemplateRequest
  | DeleteStaticContentTemplateSuccess
  | DeleteStaticContentTemplateFailure
  | SetDefaultData
  | UpdateField
  | FetchStaticContentTemplatesRequest
  | FetchStaticContentTemplatesSuccess
  | FetchStaticContentTemplatesFailure
  | FetchStaticContentTemplateRequest
  | FetchStaticContentTemplateSuccess
  | FetchStaticContentTemplateFailure
